// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"ba364f49","2319":"ba364f49","4953":"ba364f49","5143":"ba364f49"}[chunkId] + ".chunk.css";
};